import { Form, Tooltip } from "antd";
import FormInput from "component/form/form_input";
import { useAccounts } from "hook/finance/withdraw/useWithdraw";
import React from "react";
import { LuBookMarked } from "react-icons/lu";
import DialogAccount from "../dialog_account";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const WithdrawBankAccount = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpen } = useAccounts();
  const form = Form?.useFormInstance();
  const code = Form?.useWatch("code", form) || null;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!code) return null;
  return (
    <>
      <FormInput
        name="accountNumber"
        label="Tài khoản/Thẻ Nhận"
        placeholder="Nhập số tài khoản và thẻ nhận"
        variant="filled"
        style={{ minHeight: 40, position: "relative" }}
        suffix={
          <Tooltip style={{ zIndex: 2 }} title="Tài khoản gần đây">
            <LuBookMarked
              onClick={() => handleOpen(form)}
              style={{ color: "#aeaeae", fontSize: 20, cursor: "pointer" }}
            />
          </Tooltip>
        }
        rules={[
          {
            required: true,
            message: "Làm ơn nhập số tài khoản",
          },
        ]}
      />
      <Form.Item name="openAccount" hidden initialValue={false} />
      <DialogAccount />
    </>
  );
};
export default WithdrawBankAccount;
